import {
  ListColSectionsDebuggingSession,
  ListColSectionsInspections,
  ListColSectionsTestCases,
} from './constants';
import { UsageDetailsTableHeader } from './list-header';
import { UsageDetailsListItem } from './list-item';
import { TestPlanList } from '../../hooks/test-plan.hooks';
import { MobileInspection } from '@modules/test-development/pages/mobile-inspector/models/mobile-inspection.model';
import { Empty, useTranslation } from '@testsigma/atoms';
import noDataPane from '@images/no-data-pane.svg';
import { Agent } from '@models/agent.model';
import {
  DebuggerUsageDetails,
  TestPlanLicenseUsage,
} from '@modules/test-development/models/license-usage.model';

interface UsageTablePros {
  activeTab: string;
  inspections?: MobileInspection[];
  testPlanLicenseUsageList?: TestPlanLicenseUsage[];
  debuggingSessionUsageList?: DebuggerUsageDetails[];
  refresh?: () => void;
  onClose?: (isClose: boolean) => void;
  onClickReportAgent?: (
    testPlanId: string | number,
  ) => (e: React.MouseEvent) => void;
  testPlanIdVsAgents?: Record<string, Agent[]>;
}

export const UsageTable: React.FC<UsageTablePros> = ({
  activeTab,
  testPlanLicenseUsageList,
  debuggingSessionUsageList,
  inspections,
  refresh,
  onClose,
  onClickReportAgent,
  testPlanIdVsAgents,
}) => {
  const resultTable = TestPlanList('');
  const { t } = useTranslation();

  return (
    <>
      {activeTab == 'testplan' && (
        <UsageDetailsTableHeader columnDetails={ListColSectionsTestCases} />
      )}
      {activeTab == 'mobileInspection' && (
        <UsageDetailsTableHeader columnDetails={ListColSectionsInspections} />
      )}
      {activeTab == 'debuggingSession' && (
        <UsageDetailsTableHeader
          columnDetails={ListColSectionsDebuggingSession}
        />
      )}

      <div className='h-[calc(100%_-_44px)] overflow-y-auto flex flex-wrap content-baseline'>
        {activeTab == 'testplan' &&
          testPlanLicenseUsageList?.map((data, index) => (
            <div key={index} className='flex flex-wrap basis-full w-full'>
              <UsageDetailsListItem
                columnDetails={resultTable.testplanItemGenerator(
                  [data],
                  refresh,
                  onClose,
                  onClickReportAgent,
                  testPlanIdVsAgents,
                )}
              />
            </div>
          ))}
        {activeTab == 'mobileInspection' &&
          inspections?.map((data, index) => (
            <div key={index} className='flex flex-wrap basis-full w-full'>
              <UsageDetailsListItem
                columnDetails={resultTable.mobileInspactionGenerator(
                  [data],
                  refresh,
                )}
              />
            </div>
          ))}
        {activeTab == 'debuggingSession' &&
          debuggingSessionUsageList?.map((data, index) => (
            <div key={index} className='flex flex-wrap basis-full w-full'>
              <UsageDetailsListItem
                columnDetails={resultTable.debuggingSessionGenerator(
                  [data],
                  refresh,
                  onClose,
                )}
              />
            </div>
          ))}

        {activeTab == 'testplan' &&
          !testPlanLicenseUsageList?.length &&
          !inspections?.length && (
            <Empty
              className='w-full'
              description={t('runs.nothing')}
              image={<img src={noDataPane} />}
            />
          )}

        {activeTab == 'mobileInspection' && !inspections?.length && (
          <Empty
            className='w-full'
            description={t('inspections.nothing')}
            image={<img src={noDataPane} />}
          />
        )}
        {activeTab == 'debuggingSession' &&
          !debuggingSessionUsageList?.length && (
            <Empty
              className='w-full'
              description={t('debugging_sessions.empty_list.message')}
              image={<img src={noDataPane} />}
            />
          )}
      </div>
    </>
  );
};
